import React from 'react';
import PropTypes from 'prop-types';
import { Nav, Row, Col } from 'react-bootstrap';
import { getFlatRoutes } from 'helpers/utils';
import NavbarNavLink from './NavbarNavLink';

const NavbarDropdownApp = ({ items }) => {
    const routes = getFlatRoutes(items);

    return (
        <Row className="g-3">
            <Col xs={12} md={4}>
                <Nav className="flex-column">
                    {routes.reportes?.length > 0 && (
                        <>
                            <NavbarNavLink title="Reportes" />
                            {routes.reportes.map(route => (
                                <NavbarNavLink key={route.name} route={route} />
                            ))}
                        </>
                    )}
                    {routes.unTitled?.length > 0 && (
                        <>
                            <NavbarNavLink title="Leads" />
                            {routes.unTitled.map(route => (
                                <NavbarNavLink key={route.name} route={route} />
                            ))}
                        </>
                    )}
                    {routes.marketing?.length > 0 && (
                        <>
                            <NavbarNavLink title="Marketing" />
                            {routes.marketing.map(route => (
                                <NavbarNavLink key={route.name} route={route} />
                            ))}
                        </>
                    )}
                    {routes.productos?.length > 0 && (
                        <>
                            <NavbarNavLink title="Productos" />
                            {routes.productos.map(route => (
                                <NavbarNavLink key={route.name} route={route} />
                            ))}
                        </>
                    )}
                </Nav>
            </Col>
            <Col xs={12} md={4}>
                <Nav className="flex-column">
                    {routes.clientes?.length > 0 && (
                        <>
                            <NavbarNavLink title="Clientes" />
                            {routes.clientes.map(route => (
                                <NavbarNavLink key={route.name} route={route} />
                            ))}
                        </>
                    )}
                    {routes.licencias?.length > 0 && (
                        <>
                            <NavbarNavLink title="Licencias" />
                            {routes.licencias.map(route => (
                                <NavbarNavLink key={route.name} route={route} />
                            ))}
                        </>
                    )}
                </Nav>
            </Col>
            <Col xs={12} md={4}>
                <Nav className="flex-column">
                    {routes.contabilidad?.length > 0 && (
                        <>
                            <NavbarNavLink title="Contabilidad" />
                            {routes.contabilidad.slice(0, 10).map(route => (
                                <NavbarNavLink key={route.name} route={route} />
                            ))}
                            {routes.contabilidad.length > 10 && (
                                <Nav.Link 
                                    className="text-muted small fst-italic py-1"
                                    style={{ fontSize: '0.75rem' }}
                                >
                                    +{routes.contabilidad.length - 10} más opciones...
                                </Nav.Link>
                            )}
                        </>
                    )}
                    {routes.mdulos?.length > 0 && (
                        <>
                            <NavbarNavLink title="Módulos POS" />
                            {routes.mdulos.slice(0, 5).map(route => (
                                <NavbarNavLink key={route.name} route={route} />
                            ))}
                            {routes.mdulos.length > 5 && (
                                <Nav.Link 
                                    className="text-muted small fst-italic py-1"
                                    style={{ fontSize: '0.75rem' }}
                                >
                                    +{routes.mdulos.length - 5} más módulos...
                                </Nav.Link>
                            )}
                        </>
                    )}
                </Nav>
            </Col>
        </Row>
    );
};

NavbarDropdownApp.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
            name: PropTypes.string.isRequired,
            to: PropTypes.string,
            children: PropTypes.array
        }).isRequired
    ).isRequired
};

export default NavbarDropdownApp;
